// The calorie fields exactly as thisway-api serializes them: all-lowercase
// members (EF entities go over the wire verbatim — no naming policy), and
// `caloriesmode` as an integer, because the byte-backed C# enum has no
// StringEnumConverter registered.
export const CALORIES_MODE = { ADD: 0, REPLACE: 1 };

// Form inputs hold the raw string from `e.target.value`, the same idiom `price`
// already uses. The wire wants `int | null`, where null means "not set" and 0 is
// a real value (Water = 0 cal). Anything unparseable is "not set".
export const parseCaloriesInput = (raw) => {
  if (raw === null || raw === undefined) return null;
  const trimmed = String(raw).trim();
  if (trimmed === '') return null;
  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed)) return null;
  return Math.trunc(parsed);
};

export const hasCalories = (raw) => parseCaloriesInput(raw) !== null;

export const formatCalories = (raw) => {
  const parsed = parseCaloriesInput(raw);
  return parsed === null ? null : `${parsed} cal`;
};

// The upserts replace the whole row rather than patching it: an omitted
// `calories` deserializes to null and wipes the stored value, and an omitted
// `showcalories` resets to true. Normalizing at the API boundary means no call
// site can send `""`, a stringly-typed mode, or a camelCase key by accident.
export const normalizeItemCalories = (body) => ({
  ...body,
  calories: parseCaloriesInput(body.calories),
  showcalories: body.showcalories === undefined ? true : !!body.showcalories,
});

export const normalizeOptionCalories = (body) => {
  const calories = parseCaloriesInput(body.calories);
  const mode =
    Number(body.caloriesmode) === CALORIES_MODE.REPLACE
      ? CALORIES_MODE.REPLACE
      : CALORIES_MODE.ADD;
  return {
    ...body,
    calories,
    // A mode with no calories behind it is meaningless, and would otherwise
    // outlive the control that set it.
    caloriesmode: calories === null ? CALORIES_MODE.ADD : mode,
  };
};
